import { render } from "./ClyqTabs.vue?vue&type=template&id=7e2eb897"
import script from "./ClyqTabs.vue?vue&type=script&lang=js"
export * from "./ClyqTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__